import { type UUID } from '~/types/common';

import {
  CostCenterListItem,
  useQueryCostCentersInfinite,
} from '~/data/costCenter';

import { MultiItemsManager } from './MultiItemsManager';

type P = {
  readonly filterActive?: boolean | null;
  readonly isCreatingNewEntity?: boolean;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly onChange?: (selectedIds: UUID[]) => void;
  readonly onSaveSelection?: () => void;
  readonly onSelectedItemClick?: (id: UUID) => void;
  readonly parentOrganizationalUnitId?: UUID;
};

const selectCostCenters = (data: CostCenterListItem[]) =>
  data?.map(({ companyName, id, name }) => ({
    id,
    name,
    secondaryInfo: companyName,
  }));

export const MultiItemsManagerCostCenters = ({
  filterActive = true,
  isCreatingNewEntity = false,
  isDisabled = false,
  label = 'Kostenstellen',
  onChange,
  onSaveSelection,
  onSelectedItemClick,
  parentOrganizationalUnitId,
}: P) => {
  const useGetterFunctionSelectedItems = (searchString: string) => {
    const query = useQueryCostCentersInfinite({
      filterActive: filterActive ?? undefined,
      filterParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

    if (!isCreatingNewEntity) {
      return query;
    }

    return {
      data: [],
      fetchNextPage() {},
      hasNextPage: false,
      isFetchingNextPage: false,
      isLoading: false,
      totalCount: 0,
    };
  };

  const useGetterFunctionSelectableItems = (searchString: string) =>
    useQueryCostCentersInfinite({
      filterActive: filterActive ?? undefined,
      filterNotParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

  return (
    <MultiItemsManager
      fieldName="name"
      getterFunctionSelectableItems={useGetterFunctionSelectableItems}
      getterFunctionSelectedItems={useGetterFunctionSelectedItems}
      isDisabled={isDisabled}
      label={label}
      onChange={onChange}
      onSaveSelection={onSaveSelection}
      onSelectedItemClick={onSelectedItemClick}
      selectFunctionSelectableItems={selectCostCenters}
      selectFunctionSelectedItems={selectCostCenters}
    />
  );
};
